<script>
export default {
    install (Vue, options) {
      Vue.prototype.openModal = function(id, focusInput = false){
        var modalElement = this.$root.$children.find(child => {return child.$attrs.id == id;});
        modalElement.open();
        if(focusInput) {
          setTimeout(function(){
            document.getElementById(focusInput).focus();
            }, 1000);
        }
      }
      Vue.prototype.closeModal = function(id){
        var modalElement = this.$root.$children.find(child => {return child.$attrs.id == id;});
        modalElement.close();
      }
      Vue.prototype.submitForm = function(id){
        var form_object = document.getElementById(id);
        form_object.submit()
      }
      Vue.prototype.copyTextToClipboard = function(text, tooltips_feedback=false){
        navigator.clipboard.writeText(text);
        if(tooltips_feedback){
          var comp_operation = this.$root.$children.find(child => {  return child.isOpenTooltip === false; });
          comp_operation.isOpenTooltip = true;
          setTimeout(function(){ comp_operation.isOpenTooltip = false }, 500, comp_operation);
        }
      }
      Vue.prototype.currentUrl = function({deep=false}={}){
        function getParameter(parameter){
          const params = window.location.search.substr(1).split("&")
          let selected
          params.forEach(value => {
            if(value.split("=")[0]==parameter){
              selected = value
            }
          })
          return selected
        }
        if(deep == true){
          return window.location
        }
        return window.location.origin + window.location.pathname + "?" + getParameter("locale");
      }
    }
}
</script>